import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { SiteSettingsProvider } from "./contexts/SiteSettingsContext";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";

// Public Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Packages from "./pages/Packages";
import Gallery from "./pages/Gallery";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import PaymentSuccess from "./pages/PaymentSuccess";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminBookings from "./pages/admin/AdminBookings";
import AdminPackages from "./pages/admin/AdminPackages";
import AdminGallery from "./pages/admin/AdminGallery";
import AdminTestimonials from "./pages/admin/AdminTestimonials";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminCalendar from "./pages/admin/AdminCalendar";
import AdminPromoCodes from "./pages/admin/AdminPromoCodes";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminSEO from "./pages/admin/AdminSEO";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
        <SiteSettingsProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <>
                <Navigation />
                <Home />
                <Footer />
              </>
            } />
            <Route path="/about" element={
              <>
                <Navigation />
                <div className="pt-[72px]"><About /></div>
                <Footer />
              </>
            } />
            <Route path="/packages" element={
              <>
                <Navigation />
                <div className="pt-[72px]"><Packages /></div>
                <Footer />
              </>
            } />
            <Route path="/gallery" element={
              <>
                <Navigation />
                <div className="pt-[72px]"><Gallery /></div>
                <Footer />
              </>
            } />
            <Route path="/blog" element={
              <>
                <Navigation />
                <div className="pt-[72px]"><Blog /></div>
                <Footer />
              </>
            } />
            <Route path="/contact" element={
              <>
                <Navigation />
                <div className="pt-[72px]"><Contact /></div>
                <Footer />
              </>
            } />
            <Route path="/payment/success" element={
              <>
                <Navigation />
                <div className="pt-[72px]"><PaymentSuccess /></div>
                <Footer />
              </>
            } />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="bookings" element={<AdminBookings />} />
              <Route path="packages" element={<AdminPackages />} />
              <Route path="promo-codes" element={<AdminPromoCodes />} />
              <Route path="gallery" element={<AdminGallery />} />
              <Route path="testimonials" element={<AdminTestimonials />} />
              <Route path="calendar" element={<AdminCalendar />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="seo" element={<AdminSEO />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
        </SiteSettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
